import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "my-5 text-center"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-3x fa-spin fa-spinner" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "bf-accordion"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "Du hast in der Vergangenheit noch nicht an einem Kurs teilgenommen.", -1)
const _hoisted_7 = [
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UserCourseEnrollment = _resolveComponent("UserCourseEnrollment")!

  return (_ctx.loading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courseEnrollments, (courseEnrollment) => {
          return (_openBlock(), _createBlock(_component_UserCourseEnrollment, {
            key: courseEnrollment.id,
            "course-enrollment": courseEnrollment,
            context: "archive"
          }, null, 8, ["course-enrollment"]))
        }), 128)),
        (_ctx.courseEnrollments.length < 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
          : _createCommentVNode("", true)
      ]))
}